import { useRef } from 'react';

/**
 * A `React.Ref` that keeps track of the passed `value`.
 */

function useLiveRef(value) {
  var ref = useRef(value);
  ref.current = value;
  return ref;
}

export { useLiveRef };
